import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';

function ProudOf({ proudOf: { title, description, proudOf } }) {
  return (
    <Container className="py-6">
      <Row>
        <Col xs={12} md={10} lg={8} className="mx-md-5 pb-3 pt-6">
          <h2 className="mb-5">{title}</h2>
          <div dangerouslySetInnerHTML={{ __html: description }} className="text-muted" />
        </Col>
      </Row>
      <Row>
        {proudOf.map((card, index) => (
          <Col key={card._key} xs={12} lg={index % 2 === 0 ? 5 : 7} className="py-xl-4 py-3">
            <Container fluid className="position-relative px-0">
              <Row>
                <Col xs={12} className="mb-3">
                  <GatsbyImage alt={card.image?.alt ?? ''} image={card.image?.image?.asset?.gatsbyImageData ?? imgFallback} />
                </Col>
                <Col xs={12} className="mb-2">
                  <a href={card.link.url} target="_blank" rel="noreferrer" className="stretched-link">
                    <h3 className="h4 font-weight-bold text-black">{card.title}</h3>
                  </a>
                </Col>
                <Col xs={12} className="mb-3">
                  <div className="text-muted text-size-md" dangerouslySetInnerHTML={{ __html: card.description }} />
                </Col>
                <Col xs={12}>
                  <a href={card.link.url} target="_blank" rel="noreferrer" className="btn-link-primary">
                    {card.link.title}
                  </a>
                </Col>
              </Row>
            </Container>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ProudOf;
